/*
 * @Author: zyy
 * @Date: 2022-03-30 17:56:34
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-09-05 12:05:11
 * @Description: default
 */

import Qs from 'qs'
import shopRequests from "./shopRequest";
export default {
    // 商品列表
    list(params) {
        return shopRequests.get('/shop/addons/shopro/admin_api_goods/index', {
            params,
            paramsSerializer(params) {
                return Qs.stringify(params);
            }
        })
    },
    // 添加商品
    add(
        title,
        weigh,
        show_sales,
        image,
        images,
        category_ids,
        price,
        content,
        original_price,
        stock,
        weight,
        params_arr,
        dispatch_ids,
        growth_level_id
    ) {
        return shopRequests.post('/shop/addons/shopro//admin_api_goods/add', {
            title,
            weigh,
            show_sales,
            category_ids,
            image,
            images,
            price,
            cost_price: 20,
            content,
            original_price,
            dispatch_ids,
            item_free_ship: 0,
            price_free_ship: 0,
            stock,
            pay_type: 0,
            weight,
            params_arr,
            growth_level_id
        })
    },
    // 修改商品
    edit(
        id,
        title,
        weigh,
        status,
        show_sales,
        image,
        images,
        category_ids,
        price,
        content,
        original_price,
        stock,
        weight,
        params_arr,
        dispatch_ids,
        growth_level_id
    ) {
        return shopRequests.post('/shop/addons/shopro/admin_api_goods/edit', {
            id,
            title,
            weigh,
            status,
            show_sales,
            category_ids,
            image,
            images,
            price,
            cost_price: 20,
            content,
            original_price,
            dispatch_ids,
            item_free_ship: 0,
            price_free_ship: 0,
            stock,
            pay_type: 0,
            weight,
            params_arr,
            growth_level_id
        })
    },
    delete(ids) {
        return shopRequests.post('/shop/addons/shopro/admin_api_goods/del', {
            ids
        })
    },
    // 更改上架状态
    status(ids, status) {
        return shopRequests.post('/shop/addons/shopro/admin_api_goods/setStatus', {
            ids,
            status
        })
    },
    // 详情
    info(id) {
        return shopRequests.get('/shop/addons/shopro/admin_api_goods/detail', {
            params: {
                id
            }
        })
    }

}